import { css } from 'lit';
import componentStyles from '../../styles/component.styles.js';
export default css `
    ${componentStyles}
    :host {
        --track-color: var(--sgdf-color-default);
        --track-width: 3px;
        display: flex;
    }
    svg {
        animation: progress-circular-rotate 1.75s linear infinite;
        height: 100%;
        margin: auto;
        max-height: 2.5em;
        max-width: 2.5em;
        width: 100%;
    }
    circle {
        animation: progress-circular-dash 1.75s ease-in-out infinite;
        fill: transparent;
        stroke: var(--track-color);
        stroke-linecap: round;
        stroke-width: var(--track-width);
    }
    @keyframes progress-circular-rotate {
        0% {
            transform: rotate(0turn);
        }
        100% {
            transform: rotate(1turn);
        }
    }
    /* radius is set at 16px => perimeter: 100.53096491487 ~= 100 */
    @keyframes progress-circular-dash {
        0% {
            stroke-dasharray: 0, 100px;
            stroke-dashoffset: 0;
        }
        50% {
            stroke-dasharray: 80px, 100px;
            stroke-dashoffset: 0;
        }
        100% {
            stroke-dasharray: 80px, 100px;
            stroke-dashoffset: -100px;
        }
    }
`;
//# sourceMappingURL=Spinner.styles.js.map